import { ElementRef, EventEmitter } from '@angular/core';
import { PredictiveSearch } from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { SelectedData } from '@com-delta-omnichannel/mach';
import {
  BookWidgetFieldInfoTypes,
  BookWidgetFieldUpdateTypes
} from '../../constants/book-widget.constants';
import {
  BookWidgetAem,
  BookWidgetFieldInfoModal
} from '../../models/book-widget-aem.interfaces';
import { BookWidgetFieldUpdateEvent } from '../../models/book-widget-fields-update-info.interfaces';
import { getToolTipContent } from '../common';
import { InfoPopUpModalComponent } from '../common/info-popup-modal/info-popup-modal.component';

export class AppBookingWidgetExtended {
  bookWidgetAem?: BookWidgetAem | null;
  bookWidgetFieldChange!: EventEmitter<BookWidgetFieldUpdateEvent>;
  infoPopUpModalData!: BookWidgetFieldInfoModal;
  infoPopUpModal!: InfoPopUpModalComponent;
  predictiveSearchData!: PredictiveSearch;

  constructor(private elementRef: ElementRef) {}

  bookWidgetFieldChangeHandler(event: BookWidgetFieldUpdateEvent) {
    this.bookWidgetFieldChange.emit(event);
    if (event.type === BookWidgetFieldUpdateTypes.tripType) {
      setTimeout(() => {
        const element =
          this.elementRef.nativeElement.querySelector('#trip-type-field');
        element?.focus();
      });
    }
  }

  infoIconClickHandler(event: BookWidgetFieldInfoTypes) {
    if (this.bookWidgetAem && this.bookWidgetAem[event].infoModal) {
      this.infoPopUpModalData = getToolTipContent(
        this.bookWidgetAem[event].infoModal
      );
      this.infoPopUpModal.openModal();
    }
  }

  handleModalTriggerClicked(event: SelectedData) {
    this.predictiveSearchData = {
      ...this.predictiveSearchData,
      placeholder: this.preparePlaceholderText(event.type),
      value: event.selectedResult.cityCode,
      errorMessage: this.bookWidgetAem?.errorMessages['SBW015'].message,
      selectLabel: this.bookWidgetAem?.airportsField.searchModal.selectLabel
    };
  }

  preparePlaceholderText(type: string) {
    let placeholder = this.bookWidgetAem?.airportsField.searchModal.originLabel;

    if (type === 'destination') {
      placeholder =
        this.bookWidgetAem?.airportsField.searchModal.destinationLabel;
    } else if (type === 'connection') {
      placeholder =
        this.bookWidgetAem?.airportsField.searchModal.connectionAirportLabel;
    }

    return placeholder || '';
  }
}
